document.addEventListener('DOMContentLoaded', function () {
  initRevealMT();
  initGaleriaMT();
  initVariantesMT();
  initTiltMT();
  initCarruselMT();
  initFaqMT();
});

function cambiarImagenMT(img, nuevoSrc) {
  if (!img || !nuevoSrc || img.src === nuevoSrc) return;
  img.style.transition = 'opacity 0.22s ease';
  img.style.opacity = '0';
  window.setTimeout(function () {
    img.src = nuevoSrc;
    var mostrar = function () { img.style.opacity = '1'; };
    if (img.complete) {
      mostrar();
    } else {
      img.addEventListener('load', mostrar, { once: true });
    }
  }, 180);
}

function initFaqMT() {
  document.querySelectorAll('.mt-faq-item').forEach(function (details) {
    var summary = details.querySelector('summary');
    var panel = details.querySelector('.mt-faq-respuesta');
    if (!summary || !panel) return;
    var animacion = null;
    var cerrando = false;
    var abriendo = false;

    function alTerminar(abrir) {
      details.open = abrir;
      animacion = null;
      cerrando = false;
      abriendo = false;
      details.style.height = '';
      details.style.overflow = '';
    }

    function encoger() {
      cerrando = true;
      var alturaInicial = details.offsetHeight + 'px';
      var alturaFinal = summary.offsetHeight + 'px';
      details.style.overflow = 'hidden';
      if (animacion) animacion.cancel();
      animacion = details.animate({ height: [alturaInicial, alturaFinal] }, { duration: 260, easing: 'ease-out' });
      animacion.onfinish = function () { alTerminar(false); };
      animacion.oncancel = function () { cerrando = false; };
    }

    function expandir() {
      abriendo = true;
      var alturaInicial = details.offsetHeight + 'px';
      var alturaFinal = summary.offsetHeight + panel.offsetHeight + 'px';
      details.style.overflow = 'hidden';
      if (animacion) animacion.cancel();
      animacion = details.animate({ height: [alturaInicial, alturaFinal] }, { duration: 260, easing: 'ease-out' });
      animacion.onfinish = function () { alTerminar(true); };
      animacion.oncancel = function () { abriendo = false; };
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';
      if (!details.open || cerrando) {
        details.style.height = details.offsetHeight + 'px';
        details.open = true;
        requestAnimationFrame(expandir);
      } else if (details.open || abriendo) {
        encoger();
      }
    });
  });
}

function initCarruselMT() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (carrusel) {
    var pista = carrusel.querySelector('[data-mt-carrusel-pista]');
    var prev = carrusel.querySelector('[data-mt-carrusel-prev]');
    var next = carrusel.querySelector('[data-mt-carrusel-next]');
    if (!pista || !prev || !next) return;

    function pasoScroll() {
      var tarjeta = pista.querySelector(':scope > *');
      if (!tarjeta) return pista.clientWidth;
      var estilo = getComputedStyle(pista);
      var gap = parseFloat(estilo.columnGap || estilo.gap || 0);
      return tarjeta.getBoundingClientRect().width + gap;
    }

    function actualizarBotones() {
      var maxScroll = pista.scrollWidth - pista.clientWidth - 2;
      prev.disabled = pista.scrollLeft <= 2;
      next.disabled = pista.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      pista.scrollBy({ left: -pasoScroll(), behavior: 'instant' });
      actualizarBotones();
    });
    next.addEventListener('click', function () {
      pista.scrollBy({ left: pasoScroll(), behavior: 'instant' });
      actualizarBotones();
    });
    pista.addEventListener('scroll', actualizarBotones, { passive: true });
    window.addEventListener('resize', actualizarBotones);
    actualizarBotones();
  });
}

function initRevealMT() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-reveal-delay', Math.min(i % 6, 5) * 0.08 + 's');
    observer.observe(el);
  });
}

function initGaleriaMT() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-mt-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        cambiarImagenMT(main, src);
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activa'); });
        thumb.classList.add('mt-thumb-activa');
      });
    });
  });
}

function initVariantesMT() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.querySelector('[data-mt-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var precioEl = root.querySelector('[data-mt-precio]');
    var precioComparado = root.querySelector('[data-mt-precio-comparado]');
    var botonComprar = root.querySelector('[data-mt-boton-comprar]');
    var opciones = root.querySelectorAll('[data-mt-opcion]');

    function variantePorSeleccion() {
      var seleccion = [];
      var nombres = {};
      opciones.forEach(function (grupo) {
        var activo = grupo.querySelector('.mt-swatch-activo, .mt-opcion-activa');
        if (activo) {
          var idx = parseInt(grupo.getAttribute('data-mt-opcion-index'), 10);
          seleccion[idx] = activo.getAttribute('data-valor');
        }
      });
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function actualizar(cambiarImagen) {
      var variante = variantePorSeleccion();
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoDinero(variante.price);
      if (precioComparado) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioComparado.textContent = formatoDinero(variante.compare_at_price);
          precioComparado.style.display = '';
        } else {
          precioComparado.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
      if (cambiarImagen) {
        root.querySelectorAll('[data-mt-imagen-variante]').forEach(function (img) {
          img.style.display = 'none';
        });
        if (variante.featured_image) {
          var imgVariante = root.querySelector('[data-mt-imagen-variante="' + variante.id + '"]');
          if (imgVariante) {
            var principal = root.querySelector('[data-mt-galeria-principal]');
            if (principal) cambiarImagenMT(principal, imgVariante.getAttribute('data-full'));
          }
        }
      }
    }

    function formatoDinero(centavos) {
      var val = (centavos / 100).toFixed(2).replace('.', ',');
      return val + ' €';
    }

    opciones.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) {
            b.classList.remove('mt-swatch-activo', 'mt-opcion-activa');
          });
          btn.classList.add(btn.classList.contains('mt-swatch') ? 'mt-swatch-activo' : 'mt-opcion-activa');
          actualizar(true);
        });
      });
    });

    var selectorCantidad = root.querySelector('[data-mt-cantidad]');
    if (selectorCantidad) {
      root.querySelectorAll('[data-mt-cantidad-menos]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, parseInt(selectorCantidad.value || '1', 10) - 1);
          selectorCantidad.value = v;
        });
      });
      root.querySelectorAll('[data-mt-cantidad-mas]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, parseInt(selectorCantidad.value || '1', 10) + 1);
          selectorCantidad.value = v;
        });
      });
    }

    actualizar();
  });
}

function initTiltMT() {
  var soportaHover = window.matchMedia('(hover: hover)').matches;
  if (!soportaHover) return;
  document.querySelectorAll('.mt-tilt').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'rotateX(' + (y * -4) + 'deg) rotateY(' + (x * 4) + 'deg)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
